export default "__VITE_ASSET__BJRbsmnV__"